import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import { setAuthUser } from '../utils'

const { jwt } = useJwt(axios, {}, setAuthUser)
export default jwt
